<script setup>
  import SkeletonLoader from "@components/SkeletonLoader.vue";

  defineOptions({
    name: "MedicationSkeletonRow",
  });
</script>

<template>
  <li
    class="grid animate-pulse grid-cols-12 gap-x-2 border-b-1 border-gray-300 pb-2"
    :data-test="getTestId('skeleton')"
  >
    <SkeletonLoader class-names="m-1 col-span-5 h-[27px]" />
    <SkeletonLoader class-names="m-1 w-8 h-[27px]" />
    <SkeletonLoader class-names="m-1 col-span-12 h-[14px]" />
    <SkeletonLoader class-names="m-1 col-span-3 h-[27px]" />
    <SkeletonLoader class-names="m-1 col-span-2 h-[27px]" />
    <SkeletonLoader class-names="m-1 col-span-2 h-[27px]" />
    <SkeletonLoader class-names="m-1 col-span-2 h-[27px]" />
    <SkeletonLoader class-names="m-1 col-span-2 h-[27px]" />
    <SkeletonLoader class-names="m-1 col-span-1 h-[27px]" />
  </li>
</template>
